import { CSSObject } from '@emotion/serialize';
import { Component as ComponentContainer } from '@styles/layout';
import { DescriptionComponent } from '@model/content';
import { TextDescriptionFade } from '@components/common/description/TextDescriptionFade';
import { americanize } from '@util/string';

export const IntroContainer = ({ value, alignment, showReadMore }: DescriptionComponent) => {
  const textAlign = alignment && americanize(alignment);

  return (
    <ComponentContainer>
      <TextDescriptionFade
        description={value}
        isExpanded={showReadMore === false}
        styles={textAlign ? ({ textAlign } as CSSObject) : undefined}
      />
    </ComponentContainer>
  );
};
